import { BridgeChartRow } from '../types';
import { shouldUseBridgeFocusedAxis } from './bridge-extents';
import {
  applyBridgeZoomTransform,
  getBridgeZoomFloor,
  positionTotalBarsOnReferenceLine,
} from './zoom';
import { buildAbsoluteBridgeYAxis, buildBridgeFocusedYAxis } from './y-axis';

const prepareFundValueBridgeChartRenderData = (
  chartRows: Array<BridgeChartRow>,
) => {
  if (shouldUseBridgeFocusedAxis(chartRows)) {
    const zoomFloor = getBridgeZoomFloor(chartRows);
    const zoomedChartRows = applyBridgeZoomTransform(chartRows, zoomFloor);
    const yAxis = buildBridgeFocusedYAxis(zoomedChartRows);

    return {
      chartRows: positionTotalBarsOnReferenceLine(
        zoomedChartRows,
        yAxis.referenceLineValue,
      ),
      yAxis: {
        ...yAxis,
        yAxisLabelOffset: zoomFloor,
      },
    };
  }

  return {
    chartRows,
    yAxis: buildAbsoluteBridgeYAxis(chartRows),
  };
};

export default prepareFundValueBridgeChartRenderData;
